import { ContractModels, ResData } from '../types';
import { API } from './axios';

export async function createContract(data: ContractModels.CreateContractReq): Promise<ResData> {
  const response = await API.post<ResData>('/seller/contract/create', data);

  return response.data;
}
export async function updateContract(data: ContractModels.UpdateContractReq): Promise<ResData> {
  const response = await API.post<ResData>('/seller/contract/update', data);

  return response.data;
}
